import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'learn.my',
    path: 'cart',
    name: 'CartPage',
    component: () => import('@/app/M2701ShoppingCart/ShoppingCart/PgShoppingCart'),
    meta: { title: i18n.t('m2701.cartPage.title'), authenticated: true.valueOf, permissions: ['cart.viewOwn'] }
  }
]
